import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import Label from "@/components/Label";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";
import { PRODUCTS, BUSINESS } from "@/data/content";

export default function Shop() {
  return (
    <div data-testid="shop-page">
      <Seo
        title="Shop Skincare"
        path="/shop"
        description="A hand-picked edit of professional skincare we trust and use in our treatments at Barrhaven Beauty Lounge, Nepean."
      />
      <PageHero
        script="the shop"
        title="Curated skincare."
        subtitle="Take the lounge home. A hand-picked edit of the professional skincare we trust and use in our treatments."
      />

      <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-4">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.name} delay={(i % 4) * 0.07}>
              <div data-testid={`product-${i}`} className="group">
                <div className="relative aspect-[4/5] overflow-hidden rounded-2xl bg-[#f5f5f4] flex items-center justify-center">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-4 top-4 bg-white/90 px-3 py-1 text-[10px] uppercase tracking-[0.16em] backdrop-blur">
                    {p.category}
                  </span>
                </div>
                <h3 className="mt-5 font-serif-display text-2xl tracking-tight">{p.name}</h3>
                <p className="mt-1 text-sm text-[#777]">{p.note}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-20 border border-black/12 bg-[#050505] p-10 text-center text-white md:p-16 grain relative overflow-hidden">
            <div className="relative">
              <Label dark className="mb-4">In-Store Only</Label>
              <h2 className="mt-1 font-serif-display text-3xl md:text-5xl font-normal tracking-tight">
                Ask us about products at your next visit.
              </h2>
              <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-white/60">
                Our retail edit is available in the lounge. Not sure what&apos;s right for your skin?
                Book a facial and your esthetician will build a personalised routine for you.
              </p>
              <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <a
                  href={BUSINESS.bookingUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 bg-white px-8 py-4 text-sm uppercase tracking-[0.14em] text-[#050505] transition-colors duration-300 hover:bg-transparent hover:text-white border border-white"
                >
                  Book a facial <ArrowRight size={15} />
                </a>
                <a
                  href={BUSINESS.phoneHref}
                  className="inline-flex items-center gap-2 border border-white/40 px-8 py-4 text-sm uppercase tracking-[0.14em] text-white transition-colors duration-300 hover:border-white"
                >
                  {BUSINESS.phoneDisplay}
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
